/** ***********
*
* <asset.actions.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  NG6C740 [thomas.pereira.external@airbus.com]
*
* All rights reserved.
**************/

import { CreateAsset, UpdateAsset, UploadAssets } from './../../services/asset.service';
import { Family } from 'src/app/models/family';
import { Asset, ForceStatusPlayload } from 'src/app/models/asset';
import { Tracker } from 'src/app/models/tracker';
import { createAction, props } from '@ngrx/store';
import { Zone } from 'src/app/models/zone';


export const fetchAllAssets = createAction('[Assets] fetch all Assets');
export const successFetchAllAssets = createAction('[Assets] Success fetch all Assets', props<{ assets: Asset[] }>());
export const errorFetchAllAssets = createAction('[Asset] Error Assets');

export const createAsset = createAction('[Asset] create Asset', props<{ asset: CreateAsset }>());
export const successCreateAssets = createAction('[Assets] Success create Assets', props<{ payload: Asset[] }>());
export const errorCreateAssets = createAction('[Asset] Error create Asset');

export const updateAsset = createAction('[Asset] update ParentFamily', props<{ asset: UpdateAsset }>());
export const successUpdateAssets = createAction('[Assets] success update Asset', props<{ payload: Asset[] }>());
export const errorUpdateAssets = createAction('[Assets] Error update Asset');

export const deleteAsset = createAction('[Assets] delete Asset', props<{ asset: Asset }>());
export const successDeleteAssets = createAction('[Assets] success delete Assets', props<{ payload: { id: string }[] }>());
export const errorDeleteAssets = createAction('[Assets] Error update Asset');

export const mappingAllAssets = createAction('[Assets] Mapping all Assets with Zones and Families', props<{ assets: Asset[], families: { [id: string]: Family }, zones: Zone[] }>());
export const mappingSomeAssetsFamilies = createAction('[Assets] Mapping some Assets and families', props<{ families: { [id: string]: Family }, assets: Asset[], trackers: { [id: string]: Tracker }, zones: Zone[] }>());


export const forceStatus = createAction('[Asset] force status', props<{ payload: ForceStatusPlayload, asset: Asset }>());

/**
 * This action is dipatched by the tracker effect. Do not call it directly form another place, dispatch only successDissociateTrackerAsset
 */
export const __successDissociateAssetTracker = createAction('[Asset] dissociate', props<{ assetId: string }>());

/**
 * This action is dipatched by the tracker effect. Do not call it directly form another place, dispatch only successAssociateTrackerAsset
 */
export const __successAssociateAssetTracker = createAction('[Asset] associate', props<{ assetId: string, tracker: Tracker }>());

export const mappingAssetsWithTrackersData = createAction('[Assets] mapping all asset and trackers additional data', props<{ trackers: Tracker[] }>());

export const successUploadAssetPicture = createAction('[Asset] upload asset picture', props<{ assetId: string, picture: string | ArrayBuffer }>());

export const associateTrackerToNewAsset = createAction('[Asset] Create an asset & associate an existing tracker', props<{ asset: CreateAsset }>());
export const successAssociateTrackerToNewAsset = createAction('[Asset] Successful creation of an asset & association of an existing tracker', props<{ asset: Asset, tracker: Tracker }>());
export const errorAssociateTrackerToNewAsset = createAction('[Asset] Error creation of an asset & association of an existing tracker');

export const dissociateTrackerFromAsset = createAction('[Asset] Dissociate a tracker from its asset', props<{ asset: Asset, tracker: Tracker }>());
export const successDissociateTrackerFromAsset = createAction('[Asset] Success dissociate a tracker from its asset', props<{ asset: Asset, tracker: Tracker }>());
export const errorDissociateTrackerFromAsset = createAction('[Asset] Error dissociate a tracker from its asset');

export const importAssets = createAction('[Asset] Import Asset', props<{ asset: UploadAssets['assets'] }>());
export const successImportAssets = createAction('[Assets] Success import Assets');
export const errorImportAssets = createAction('[Asset] Error import Asset');